var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.896,
    height: 61.896,
    viewBox: "0 0 61.896 61.896",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_6794",
    "data-name": "Group 6794",
    transform: "translate(-49.182 -75)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11091",
    "data-name": "Group 11091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_5865",
    "data-name": "Path 5865",
    transform: "translate(111.078 136.896) rotate(180)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25,0h27.4A17.25,17.25,0,0,1,61.9,17.25v27.4A17.25,17.25,0,0,1,44.647,61.9H17.25A17.25,17.25,0,0,1,0,44.647V17.25A17.25,17.25,0,0,1,17.25,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17.24984359741211 2 C 13.17646408081055 2 9.346893310546875 3.586261749267578 6.466571807861328 6.466571807861328 C 3.586261749267578 9.346889495849609 2.000003814697266 13.17646026611328 2.000003814697266 17.24983978271484 L 2.000003814697266 44.64664077758789 C 2.000003814697266 48.72002029418945 3.586261749267578 52.54959106445312 6.466571807861328 55.42990112304688 C 9.346893310546875 58.31021881103516 13.17646408081055 59.89648056030273 17.24984359741211 59.89648056030273 L 44.64664459228516 59.89648056030273 C 48.72002410888672 59.89648056030273 52.54959106445312 58.31021881103516 55.42990112304688 55.42990112304688 C 58.31022262573242 52.54959106445312 59.89648056030273 48.72002029418945 59.89648056030273 44.64664077758789 L 59.89648056030273 17.24983978271484 C 59.89648056030273 13.17646026611328 58.31022262573242 9.346889495849609 55.42990112304688 6.466571807861328 C 52.54959106445312 3.586261749267578 48.72002410888672 2 44.64664459228516 2 L 17.24984359741211 2 M 17.24984359741211 0 L 44.64664459228516 0 C 54.1734619140625 0 61.89648056030273 7.723011016845703 61.89648056030273 17.24983978271484 L 61.89648056030273 44.64664077758789 C 61.89648056030273 54.1734619140625 54.1734619140625 61.89648056030273 44.64664459228516 61.89648056030273 L 17.24984359741211 61.89648056030273 C 7.723011016845703 61.89648056030273 3.814697265625e-06 54.1734619140625 3.814697265625e-06 44.64664077758789 L 3.814697265625e-06 17.24983978271484 C 3.814697265625e-06 7.723011016845703 7.723011016845703 0 17.24984359741211 0 Z",
    stroke: "none",
    fill: "#a8c2d7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5312",
    "data-name": "Path 5312",
    d: "M19.826,23.892A4.054,4.054,0,0,1,16.95,22.7L1.191,6.942A4.067,4.067,0,0,1,6.942,1.191L19.826,14.075,32.71,1.191a4.067,4.067,0,1,1,5.751,5.751L22.7,22.7A4.054,4.054,0,0,1,19.826,23.892Z",
    transform: "translate(91.075 85.334) rotate(90)",
    fill: "#a8c2d7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.47e90ebb8c7985eca21ad83c990c2f8c.svg";
export { ForwardRef as ReactComponent };